/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "./index.scss";

import { duration } from "utils";
// ui
import { Drawer } from "antd";

// amination
import { Zoom, Fade } from "react-reveal";

// images
import Logo from "../../../assets/icons/logo-ic-larget.svg";
import LogoMobile from "../../../assets/icons/logo-mb.svg";
import Menu from "../../../assets/icons/menu.svg";

import PdfFile from "../../../assets/docs/lightpaper.pdf";

const Header = (props) => {
  const {
    onView,
    homeRef,
    productsRef,
    teamRef,
    tokenRef,
    faqRef,
    contactRef,
    // buyTokenRef,
    showHeader,
  } = props;

  const [openMenus, setOpenMenus] = useState(false);

  const handleToggleMenus = () => {
    setOpenMenus(!openMenus);
  };

  return (
    <div className={`header ${showHeader ? "fixedHeader" : ""}`}>
      <div className="headerContent customContainer">
        <div className="viewDesktop">
          <Zoom duration={duration}>
            <a href="/" className="logo">
              <img src={Logo} alt="" />
              <span>Precog</span>
            </a>
          </Zoom>

          <div className="noneMenu"></div>

          <Fade top duration={duration}>
            <div className="mainMenu ">
              <a onClick={() => onView(homeRef)}>Home</a>
              <a onClick={() => onView(productsRef)}>Products</a>
              <a onClick={() => onView(teamRef)}>Team</a>
              <a onClick={() => onView(tokenRef)}>Token</a>
              <a onClick={() => onView(faqRef)}>FAQ</a>
              <a
                href={PdfFile}
                target="_blank"
                rel="noreferrer"
                // download
              >
                Lightpaper
              </a>
              <a onClick={() => onView(contactRef)}>Contact</a>
              {/* <a onClick={() => onView(buyTokenRef)}></a> */}
              {/* <a
                href="https://app.gitbook.com/login/precog/precog-lightpaper-jan-2021"
                target="_blank"
                rel="noreferrer"
              >
                Overview
              </a>
              <a
                href="https://app.gitbook.com/login/precog/precog-lightpaper-jan-2021"
                target="_blank"
                rel="noreferrer"
              >
                Developer
              </a> */}
              {/* <address>
                <a href="mailto:info@pre-cog.io">Contact</a>
              </address> */}
            </div>
          </Fade>
        </div>

        <div className="viewMobile">
          <a href="/" className="logo">
            <img src={LogoMobile} alt="" />
          </a>
          <a className="btnMenu" onClick={handleToggleMenus}>
            <img src={Menu} alt="" />
          </a>
        </div>

        <Drawer
          className="mobileMenus"
          title={
            <a href="/" className="logo">
              <img src={LogoMobile} alt="" />
            </a>
          }
          placement="left"
          closable={true}
          onClose={handleToggleMenus}
          visible={openMenus}
        >
          <div className="mainMenu ">
            <a onClick={() => onView(homeRef)}>Home</a>
            <a onClick={() => onView(productsRef)}>Products</a>
            <a onClick={() => onView(teamRef)}>Team</a>
            <a onClick={() => onView(tokenRef)}>Token</a>
            <a onClick={() => onView(faqRef)}>FAQ</a>
            <a
              href={PdfFile}
              target="_blank"
              rel="noreferrer"
              // download
            >
              Lightpaper
            </a>
            <a onClick={() => onView(contactRef)}>Contact</a>
            {/* <a onClick={() => onView(buyTokenRef)}>Buy token</a> */}
            {/* <a
                href="https://app.gitbook.com/login/precog/precog-lightpaper-jan-2021"
                target="_blank"
                rel="noreferrer"
              >
                Overview
              </a>
              <a
                href="https://app.gitbook.com/login/precog/precog-lightpaper-jan-2021"
                target="_blank"
                rel="noreferrer"
              >
                Developer
              </a> */}
            {/* <address>
                <a href="mailto:info@pre-cog.io">Contact</a>
              </address> */}
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default Header;
